var _rect, _rect2, _rect3, _rect4, _rect5, _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 305 282",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 137,
    height: 137,
    x: 11,
    y: 15,
    stroke: "#000",
    strokeWidth: 14,
    rx: 68.5
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    x: 6,
    y: 9,
    fill: "#fff",
    stroke: "#000",
    strokeWidth: 12,
    rx: 20
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    x: 113,
    y: 9,
    fill: "#fff",
    stroke: "#000",
    strokeWidth: 12,
    rx: 20
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    x: 113,
    y: 116,
    fill: "#fff",
    stroke: "#000",
    strokeWidth: 12,
    rx: 20
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    x: 6,
    y: 116,
    fill: "#fff",
    stroke: "#000",
    strokeWidth: 12,
    rx: 20
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m183.154 82.622-6.071-6.07 1.74-1.37c1.82-1.573 4.386-4.016 7.699-7.328 5.706-5.706 12.199-7.14 19.478-4.303 2.276.882 4.494 2.144 6.653 3.784 1.079.82 1.93 1.549 2.554 2.184l9.391 9.485c21.332 23.614 36.35 43.042 45.054 58.285 8.71 15.237 15.299 27.624 19.765 37.161l-67.178 67.548c-38.709-25.31-76.952-36.911-114.73-34.801-16.662-25.804-6.237-36.716 31.276-32.738l-69.038-69.037a29.835 29.835 0 0 1-1.795-2.147c-1.66-2.141-2.958-4.321-3.896-6.542-2.806-6.644-1.999-12.486 2.425-17.526 5.046-4.429 10.89-5.24 17.534-2.433 2.221.938 4.402 2.236 6.542 3.895.858.66 1.57 1.262 2.138 1.805l23.151 23.151 1.555-1.554c1.819-1.574 4.386-4.016 7.698-7.329 5.706-5.706 12.199-7.14 19.478-4.303 2.276.882 4.494 2.144 6.653 3.785.864.654 1.582 1.25 2.156 1.786l-7.773-7.773 1.555-1.554c1.82-1.574 4.386-4.016 7.699-7.329 5.706-5.706 12.198-7.14 19.478-4.303 2.276.883 4.494 2.144 6.653 3.785.863.654 1.582 1.25 2.156 1.786Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 3,
    strokeWidth: 14.17,
    d: "M183.154 82.622a27.584 27.584 0 0 0-2.156-1.786c-2.16-1.641-4.377-2.903-6.653-3.785-7.28-2.837-13.772-1.403-19.478 4.303-3.313 3.313-5.879 5.755-7.699 7.329l-1.555 1.554 7.773 7.773m29.768-15.388-6.071-6.07 1.74-1.37c1.82-1.573 4.386-4.016 7.699-7.328 5.706-5.706 12.199-7.14 19.478-4.303 2.276.882 4.494 2.144 6.653 3.784 1.079.82 1.93 1.549 2.554 2.184l9.391 9.485c21.332 23.614 36.35 43.042 45.054 58.285 8.71 15.237 15.299 27.624 19.765 37.161l-67.178 67.548c-38.709-25.31-76.952-36.911-114.73-34.801-16.662-25.804-6.237-36.717 31.276-32.738l-69.038-69.037a29.616 29.616 0 0 1-1.795-2.147c-1.66-2.14-2.958-4.321-3.896-6.542-2.806-6.644-1.999-12.486 2.425-17.526 5.046-4.429 10.89-5.24 17.534-2.433 2.221.938 4.402 2.236 6.542 3.895.858.66 1.57 1.262 2.138 1.805l23.151 23.151m67.308-23.003.231.231 12.63 12.686m-42.629 2.47 13.88 13.88m-13.88-13.88a27.42 27.42 0 0 0-2.156-1.785c-2.159-1.641-4.377-2.903-6.653-3.785-7.279-2.837-13.772-1.403-19.478 4.303-3.312 3.313-5.879 5.755-7.698 7.329l-1.555 1.554m0 0 21.652 21.652m58.517-31.738 2.906 2.85m-2.906-2.85 4.479 4.59"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.05043f9886f5b709d85977045f11ed59.svg";
export { ForwardRef as ReactComponent };